import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa6';
import './TermsAndPrivacy.css';

const RefundPolicy = () => {
    return (
        <div className="terms-privacy-container">
            <h1>Refund & Cancellation Policy</h1>

            <div className="terms-privacy-content">
                <p>Last Updated: January 21, 2026</p>

                <h2>1. AUTOMATED REFUNDS (100% REFUND)</h2>
                <p>A Student is automatically refunded if:</p>
                <ul>
                    <li>The Professor declines the Session Request.</li>
                    <li>The Professor fails to respond to a request within 48 hours.</li>
                    <li>The Professor cancels the session at any time.</li>
                </ul>

                <h2>2. STUDENT CANCELLATIONS</h2>
                <ul>
                    <li><strong>Standard Cancellation:</strong> If a Student cancels more than 24 hours before the session, a full refund is issued (minus processing fees).</li>
                    <li><strong>Late Cancellation:</strong> If a Student cancels within 24 hours of the start time, a 50% cancellation fee may be applied.</li>
                    <li><strong>No-Show:</strong> If a Student does not join the session within 15 minutes of the start time, the session is treated as "Completed" and no refund is issued.</li>
                </ul>

                <h2>3. DISPUTES & ESCROW PROTECTION</h2>
                <p>If a session is unsatisfactory or the Professor fails to show up:</p>
                <ul>
                    <li>The Student must file a "Dispute" within 24 hours of the scheduled session end.</li>
                    <li>The Escrow funds will be frozen in a "DISPUTED" state.</li>
                    <li>The EdVergenceX Compliance team will investigate and issue a final decision within 3-5 business days.</li>
                </ul>

                <h2>4. REFUND PROCESSING TIME</h2>
                <p>Approved refunds are processed immediately but may take 5-10 business days to appear on the user's bank statement.</p>

                <div className="back-button-container">
                    <Link to="/" className="back-button">
                        <FaArrowLeft style={{ marginRight: '8px' }} /> Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default RefundPolicy;


